import React, { PropTypes } from 'react';
import NumberFormat from 'react-number-format';

export function quantity (props) {
  const {
    options,
    value,
    onChange,
    required,
  } = props;

  return (
    <Quantity
      required={required}
      value={value}
      onChange={onChange}
      {...options}
    />
  );
}

class Quantity extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      name,
      value,
      onChange,

      suffix='',
      prefix='',
      unit=['', ''],
      paddingRight=[0, 0],
      required,

    } = this.props

    return (
      <div className='number-input form-input'>
        <NumberFormat
          style={{paddingRight: value > 1 ? paddingRight[1] : paddingRight[0] }}
          value={value || ''}
          allowNegative={false}
          onChange={(event)=>{
            let value = event.target.value || '0'
            onChange(parseFloat(value.replace(suffix, '').replace(prefix, '')));
          }}
          placeholder="0"
          required={required}
          className='form-control'
          prefix={prefix}
          suffix={suffix} />
        <div className='unit-marker'>{value > 1 ? unit[1] : unit[0]}</div>
      </div>
    );

  }
}

export default Quantity;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/Quantity.js